module.exports = __webpack_public_path__ + "static/media/CC20-AP130-12.2a070d9c.png";